import { createFeatureSelector, createSelector } from '@ngrx/store';
import { find } from 'lodash';
import { GenesysCloudPresenceState } from '../genesys-cloud-presence.state';
import { featureKey } from '../reducers/presence.reducers';
import { selectUser } from '../../users/selectors/user.selectors';
import { presenceTopicName } from '../helpers/notification-topics.helper';
import { SystemPresenceType } from '../models/system-presence.model';

const agentSelectablePresenceTypes = new Set([SystemPresenceType.OnQueue, SystemPresenceType.Away]);

export const selectState = createFeatureSelector<GenesysCloudPresenceState>(featureKey);
export const selectPresences = createSelector(selectState, state => state.presences);
export const selectActivePresence = createSelector(selectState, state => state.active);
export const selectOnQueuePresence = createSelector(selectState, state => find(state.presences, { name: SystemPresenceType.OnQueue }));
export const selectAwayPresence = createSelector(selectState, state => find(state.presences, { name: SystemPresenceType.Away }));
export const selectAgentSelectablePresences = createSelector(
  selectPresences,
  presences => presences?.filter(p => agentSelectablePresenceTypes.has(p.name)) || []);
export const selectPresenceNotificationTopicName = createSelector(selectUser, user => presenceTopicName(user?.id));
export const selectActivePresenceIsOnQueue = createSelector(
  selectActivePresence,
  selectOnQueuePresence,
  (activePresence, onQueuePresence) => activePresence && onQueuePresence ? activePresence?.id === onQueuePresence?.id : false
);
